// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-03591d1d]{text-decoration:none!important}.breadcrumbs[data-v-03591d1d]{min-width:100%}p[data-v-03591d1d]{font-size:18px;font-size:.9rem}.seperator[data-v-03591d1d]{ffont-size:.6rem;line-height:20px;vertical-align:middle;padding-left:2px;padding-right:4px;color:#d9d9d9}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
